import { Component, OnInit } from '@angular/core';

import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { CommonService } from "../../../shared/common.service";
import { AuthServiceLocal } from "../../auth.service";
import { ActivatedRoute, Router } from "@angular/router";
import { HttpResponse } from "@angular/common/http";
import { StreamService } from "../../../shared/stream.service";
import { MatSnackBar } from "@angular/material";
import Swal from "sweetalert2";
@Component({
  selector: 'app-signin',
  templateUrl: './signin.component.html',
  styleUrls: ['./signin.component.scss']
})
export class SigninComponent implements OnInit {
  loginForm: FormGroup;
  resetForm:FormGroup;
  formSubmitted:boolean = false;
  isLoading:boolean = false;
  show: boolean = false;
  isLogin:boolean = true;
  emailPattern = /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+$/;
  message: string = "";
  type:string = "0";
  token="";
  constructor(    
    private fb: FormBuilder,
    private authServices: AuthServiceLocal,
    private commonService: CommonService,
    private streamService: StreamService,
    private router: Router,
    private _snackBar: MatSnackBar,
    private route: ActivatedRoute) { }
    projectDetail:any
  ngOnInit() {
    
    this.route.queryParams.subscribe((param) => {
      this.token = param["id"];

      if(this.token){
        this.commonService.setStorage(
          "token",
         this.token
        );
        
      }
    });
    this.projectDetail = JSON.parse(localStorage.getItem("full_project")) || "noemail";
    this.initialiseForms();

 }
  // login() {
  //   this.router.navigate(["main/admin/dashboard"]);
  //  
  // }
  password() {
    this.show = !this.show;
  }
  initialiseForms() {
    this.loginForm = this.fb.group({
      email: ["", [Validators.required, Validators.pattern(this.emailPattern)]],
      password: ["", [Validators.required, Validators.minLength(8)]],
      type: ["0", [Validators.required]]
    });
    this.resetForm = this.fb.group({
      email: ["", [Validators.required, Validators.pattern(this.emailPattern)]],
    });
  }

  forgotPassowrd() {
    this.formSubmitted = true;
    if (this.resetForm.valid) {
      let req = {
        email: this.resetForm.controls["email"].value.toLowerCase(),
      };
      this.isLoading = true;
      this.authServices.forgotPassword(req).subscribe(
        (res) => {
          if ((res["message"] = "Success")) {
            this._snackBar.open("Check Your Email", "", {
              duration: 3000,
                horizontalPosition: "right",
                verticalPosition: "top",
               panelClass: ["success"],
             });
            
          } else {
          }
        },
        (err) => {
          this._snackBar.open("Email Verified", "", {
            duration: 3000,
              horizontalPosition: "right",
              verticalPosition: "top",
             panelClass: ["success"],
           });
        }
      );


    }


  }

  login() {
   
        this.formSubmitted = true;
          let req = {
            email: this.loginForm.controls["email"].value,
            password: this.loginForm.controls["password"].value
          };
          this.isLoading = true;
          this.authServices.validateLogin(req).subscribe (
            (res: HttpResponse<any>) => {

              this.isLoading = false;
              if ((res["message"] = "Success")) {
                localStorage.setItem('userData',JSON.stringify(res['data']))
                if(res['data']["accessToken"]) {
                  this.commonService.setStorage(
                    "token",
                    res['data']["accessToken"]
                  );
                }
                let principalColor = "#5C0606"
                let coordinatorColor = "#1ba1e2"
                let researchAdminColor = "#836200"
                let admincolor = "#880ED4"
        document.documentElement.style.setProperty('--theme_primary', this.projectDetail['primaryThemeColor']);
        if( res['data'].tuftsRole.length > 1) {
          document.documentElement.style.setProperty('--theme_secondary',coordinatorColor);
        }
        if( res['data'].tuftsRole.length == 1 && res['data'].tuftsRole[0] == "CTO") {
          document.documentElement.style.setProperty('--theme_secondary',admincolor);
        }
        if( res['data'].tuftsRole.length == 1 && res['data'].tuftsRole[0] == "Admin") {
          document.documentElement.style.setProperty('--theme_secondary',admincolor);
        }
        if( res['data'].tuftsRole.length == 1 && res['data'].tuftsRole[0] == "CTMS Support") {
          document.documentElement.style.setProperty('--theme_secondary',admincolor);
        }
        if( res['data'].tuftsRole.length == 1 && res['data'].tuftsRole[0] == "Principal Investigator") {
          document.documentElement.style.setProperty('--theme_secondary',principalColor);
        }
        if( res['data'].tuftsRole.length == 1 && res['data'].tuftsRole[0] == "Study Coordinator") {
          document.documentElement.style.setProperty('--theme_secondary',coordinatorColor);
        }
        if( res['data'].tuftsRole.length == 1 && res['data'].tuftsRole[0] == "Research Admin") {
          document.documentElement.style.setProperty('--theme_secondary',researchAdminColor);
        }
                this.projectDetail = JSON.parse(localStorage.getItem("full_project")) || "noemail";                
                if(this.projectDetail['loginNavigationLink']) {
                  if(res['data'].tuftsRole.length > 1) {
                    this.router.navigate([this.projectDetail['loginNavigationLink']]);
                  } else {
                    this.router.navigate(['main/tuft-dashboard']);
                  }                  
                } else {
                  this.router.navigate(['main/tuft-dashboard']);
                }
                
              } else {
              }
            },
            err => {
              // Swal.fire({
              //   icon: "error",
              //   title: err.error.data.message
              // });
             this._snackBar.open(err.error.data.message, "", {
                duration: 3000,
                  horizontalPosition: "right",
                  verticalPosition: "top",
                 panelClass: ["success"],
               });
              this.isLoading = false;
            }
          );
  }
  }
